/* global __HOT__ */
declare var __HOT__: string

import domready from 'domready'
import { toArray, createUniqueId } from '@nrk/dh-utils'
import { createErrorReporter } from '../../lib/errorReporting'
import { App } from './components/App'
import { createGoogleAnalyticsTracker } from '@nrk/dh-analytics-utils'
import { getContextId } from '../../lib/getContextId'

const { h, render } = require('preact')

const {
  'root-goalshow-player': rootElementClassName
} = require('./components/App.css')
window[rootElementClassName] = window[rootElementClassName] || {}

function init() {
  findElements(rootElementClassName).forEach(el => {
    el.id = createUniqueId()
    window[rootElementClassName][el.id] = true

    // Extract values sent from server
    const name = el.getAttribute('data-name')

    const preloadedState = JSON.parse(
      decodeURIComponent(el.getAttribute('data-preloaded-state'))
    )
    const errorTrackingEnabled =
      el.getAttribute('data-error-tracking-enabled') === 'true'

    // setup error reporting
    const simpleErrorReport = createErrorReporter(name, errorTrackingEnabled)
    // @ts-ignore
    simpleErrorReport.listenAndCatch()

    // Extract metadata required to create google analytics tracker
    const gaPropertyId = el.getAttribute('data-ga-property-id')

    const metadata = JSON.parse(
      decodeURIComponent(el.getAttribute('data-metadata'))
    )
    const { title, selfId, published } = metadata

    // create google analytics tracker
    const googleAnalyticsTracker = (() => {
      try {
        return createGoogleAnalyticsTracker({
          name: 'dh',
          gaPropertyId,
          self: {
            id: selfId,
            title,
            publishedDate: published ? new Date(published) : null
          },
          context: {
            id: getContextId(document.location.href)
          }
        })
      } catch (err) {
        console.log('Error in creation of GA tracker', err)
        return {}
      }
    })()

    // @ts-ignore
    googleAnalyticsTracker.sendEvent({
      category: `dh-fotballvm-2018`,
      action: 'load',
      label: 'goalshow-player'
    })

    // const sendError = message => {
    //   try {
    //     // @ts-ignore
    //     simpleErrorReport.sendErrorReport({ message })
    //   } catch (err) {
    //     console.error('Error in sendError', err)
    //   }
    // }

    // const sendGaEvent = eventObj => {
    //   // @ts-ignore
    //   googleAnalyticsTracker.sendEvent({
    //     category: `dh-modul-${name}`,
    //     ...eventObj
    //   })
    // }

    render(<App {...preloadedState} />, el, el.firstChild)
  })
}

function findElements(className) {
  return toArray(document.getElementsByClassName(className)).filter(
    el => !isInitialized(el, className)
  )
}

function isInitialized(el, className) {
  return el.id && window[className][el.id]
}

domready(init)
